<template>
  <div>
    <div class="card top-draft" style="margin-bottom: 0px">
      <!-- <div class="col-lg-12 mg-top-1">
        <b-button variant="primary" @click="toCreate()" v-if="power['添加']">
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div> -->

      <div class="col-lg-12 list-header pad-header-bg clearfix">
        <div class="app-list-sort header-item-fix">
          <b-dropdown>
            <template v-slot:button-content>
              <sort-icon />
            </template>
            <b-dropdown-item
              v-for="(item, index) in sortList"
              :key="index"
              @click="listSort(item)"
            >
              <span class="pull-left" v-if="pageParams.sortBy == item.value">
                <i
                  v-if="pageParams.order == 'desc'"
                  class="bx bx-down-arrow-alt font-size-18 pull-left"
                ></i>
                <i
                  v-if="pageParams.order == 'asc'"
                  class="bx bx-up-arrow-alt font-size-18"
                ></i>
              </span>
              <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                item.text
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div class="header-item-fix">
          <b-form-input
            class="m-r-10"
            size="sm"
            type="text"
            v-model="pageParams.contentKeyword"
            @keyup.enter.native="search"
            placeholder="搜索内容"
          ></b-form-input>
          <b-form-input
            class="m-r-10"
            size="sm"
            type="text"
            v-model="pageParams.title"
            placeholder="搜索标题"
            @keyup.enter.native="search"
          ></b-form-input>
          <b-button size="sm" variant="primary" @click="search()">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
        <div class="header-item-fix">
          <b-form-select
            @change="search()"
            v-model="pageParams.showState"
            class="form-select"
            :options="statusList"
            type="text"
          ></b-form-select>
        </div>
        <div class="header-item-fix">
          <search-tag-name
            ref="searchTagNameRef"
            :init-list="cacheTagList"
            @change="searchTagChange"
          ></search-tag-name>
        </div>
        <b-button
          size="sm"
          variant="primary"
          @click="toCreate()"
          v-if="power['添加']"
        >
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div>

      <div class="col-lg-12">
        <el-table
          v-loading="tableLoading"
          :data="items"
          style="width: 100%"
          :stripe="true"
          @selection-change="tableSelectionChange"
        >
          <el-table-column fixed="left" type="selection" align="center">
          </el-table-column>
          <el-table-column label="ID" prop="id" width="60" fixed="left">
          </el-table-column>
          <el-table-column label="标题" min-width="200" fixed="left">
            <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <show-repeat-title
                  v-if="repeatTitle"
                  :repeatTitle="repeatTitle"
                  :title="item.row.title"
                ></show-repeat-title>
                <span v-else>{{ item.row.title }}</span>
              </div>
            </template>
            <!-- <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <span>{{ item.row.title }}</span>
              </div>
            </template> -->
          </el-table-column>
          <el-table-column label="封面" width="120">
            <template slot-scope="item">
              <img
                v-if="item.row.image"
                class="w-3-rem"
                :src="`${item.row.image}`"
                alt
              />
              <img
                v-if="!item.row.image"
                class="w-3-rem"
                src="@/assets/images/image-null.jpg"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column label="浏览量" width="80">
            <template slot-scope="item">
              <view-num :item="item.row"></view-num>
            </template>
          </el-table-column>
          <el-table-column label="评论" width="80">
            <template slot-scope="item">
              {{ item.row.commentNum || "0" }}
            </template>
          </el-table-column>
          <el-table-column label="角标" width="80">
            <template slot-scope="item">
              {{ item.row.subscript || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="显示状态" width="80">
            <template slot-scope="item">
              <el-tooltip
                v-if="power['显示/隐藏']"
                :content="item.row.showState == 1 ? '点击隐藏' : '点击显示'"
              >
                <span
                  @click="batchHide(item.row)"
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  @click="batchShow(item.row)"
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </el-tooltip>
              <div v-if="!power['显示/隐藏']">
                <span
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发稿人/创建时间" width="170">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.creator || "--" }}</span>
                <span>{{ item.row.createdAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核人/审核时间" width="170">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.verifyName || "--" }}</span>
                <span>{{ item.row.verifiedAt }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="预览链接" width="200">
            <template slot-scope="item">
              <a
                target="_blank "
                v-if="item.row.previewUrl"
                :href="item.row.previewUrl"
                >{{ item.row.previewUrl }}</a
              ><span v-else>--</span>
            </template>
          </el-table-column> -->
          <el-table-column label="发布日期" width="170" prop="publishedAt">
          </el-table-column>
          <!-- <el-table-column label="推荐数" width="80">
            <template slot-scope="item">
              {{ item.row.viewNum || "0" }}
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="165">
            <template slot-scope="item">
              <div class="optWrap" style="display: flex; flex-wrap: wrap">
                <div style="padding: 5px 0">
                  <button
                    v-if="power['编辑信息']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row, 'isModify')"
                  >
                    编辑信息
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['编辑详情']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['移除']"
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                  >
                    移除
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表
        pageCallback 分页组件的回调方法 -->
        <pagination
          class="bath_r_20"
          :isBatch="true"
          :total="pageTotal"
          :batchs="batchs"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>
        <media-dialog ref="media" @pageCallback="pageCallback"></media-dialog>
      </div>
    </div>
    <el-drawer :visible.sync="drawer" size="450px" :direction="direction">
      <iframe
        ref="iframe"
        class="iframe-item"
        :src="rowData.previewUrl"
      ></iframe>
    </el-drawer>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import article from "@/server/api/article";
import mediaDialog from "./mediaDialog";
import tags from "@/server/api/tags";
import { getPreLink, copyLink, getCopyLink, changeList } from "@/util/fun.js";
import ShowRepeatTitle from "@/components/ShowRepeatTitle.vue";
import searchTagName from "@/components/searchTagName";

/**
 * Contacts-list component
 */
export default {
  components: {
    mediaDialog,
    ShowRepeatTitle,
    searchTagName,
  },
  data() {
    return {
      searchTagName: "",
      searchTagList: [],
      rowData: {},
      drawer: false,
      direction: "rtl",
      power: "",
      choiceListIds: [], //当前所选择的id
      pageParams: {
        page: 1,
        pageSize: 30,
        type: 2, // 0:草稿，1:初遍池，2：文章列表
        showState: "",
        sortBy: "",
        order: "",
        contentKeyword: "",
        mediaId: "",
        title: "",
      },
      currentTag: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        // { text: "显示", value: "1" },
        // { text: "隐藏", value: "2" },
        // { text: "撤稿", value: "3" },
        // { text: "修改媒体号", value: "4" },
      ],
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "显示", value: "1" },
        { text: "隐藏", value: "0" },
      ],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      tagStatus: "0",
      tableLoading: false,
      currentQRcode: "",
      repeatTitle: "",
      pageTotal: 0,
      cacheTagList: [],
    };
  },

  created() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    this.power = this.utils.currentPower("创作平台-文章发布");
    if (this.power["显示/隐藏"]) {
      this.batchs.push({ text: "显示", value: "1" });
      this.batchs.push({ text: "隐藏", value: "2" });
    }
    if (this.power["撤稿"]) {
      this.batchs.push({ text: "撤稿", value: "3" });
    }
    if (this.power["编辑信息"] || this.power["编辑详情"]) {
      // this.batchs.push({ text: "修改媒体号", value: "4" });
    }
    // this.batchs = this.utils.currentBatchs(this.batchs, this.power);
    //从详情、评论返回文章列表时不重新调用列表接口
    let obj = this.getCache("article-list");
    if (obj) {
      if (obj.pageParams) {
        this.pageParams = obj.pageParams;
        if (obj.pageParams.title) {
          this.repeatTitle = obj.pageParams.title;
        }
      }
      if (obj.cacheTagList) {
        this.cacheTagList = obj.cacheTagList;
      }
    }
    if (obj && obj.list && obj.list[0]) {
      console.log("使用缓存", obj.list);
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      //从详情返回时更新列表数据
      obj = this.getCache("article-edit");
      if (obj && obj.id) {
        //检测编辑的内容id是否在本列表
        let judge = this.items.some((item) => {
          if (item.id == obj.id) {
            return true;
          }
        });
        //获取编辑的内容详情
        article.detail({ id: obj.id }).then((res) => {
          console.log("内容详情", res);
          let detail = res.data;
          if (detail.verifyState == 1) {
            this.addCache("article-edit", "");
            if (judge) {
              //如果审核状态为通过且在本列表则更新对应数据
              this.items = this.items.map((item) => {
                if (item.id == obj.id) {
                  return { ...item, ...detail };
                } else {
                  return item;
                }
              });
              this.updateCache("article-list", {
                list: this.items,
              });
            } else {
              this.getList(false); //不显示加载图标更新列表
            }
          } else {
            //如果审核状态未通过但之前在本列表则删除对应数据
            if (judge) {
              this.pageTotal -= 1;
              this.items = changeList("delete", this.items, [detail.id], "id");
            }
          }
        });
      }
    } else {
      this.getList();
      this.addCache("article-edit", "");
    }
  },

  beforeDestroy() {
    this.addCache("article-list", {
      list: this.items,
      pageTotal: this.pageTotal,
      cacheTagList: this.$refs.searchTagNameRef.getTagNamesByIdString(
        this.pageParams.tagId
      ),
      pageParams: this.pageParams,
    });
  },

  methods: {
    showPre(item) {
      this.rowData.previewUrl = getPreLink(item);
      this.drawer = true;
    },
    async showQRcode(item) {
      let url = getCopyLink(item);
      if (url) {
        this.currentQRcode = await this.$qrCode.toDataURL(url);
      }
    },
    copyUrl(item) {
      copyLink(getCopyLink(item), "链接");
    },
    tableSelectionChange(selectValues) {
      this.choiceListIds = [];
      selectValues.map((val) => {
        this.choiceListIds.push(val.id);
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    //获取列表数据
    getList(showLoading) {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      // this.$refs.loading.show();
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      article.list(params).then((resp) => {
        if (resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.updateCache("article-list", {
              list: this.items,
            });
            console.log(this.items);
            this.pageTotal = resp.data.total || 0;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }

      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        if (this.choiceListIds.length < 1) {
          this.info("未选择内容");
          return;
        }
        //处理批量操作
        console.log(this.choiceListIds, "批量的id", obj.batch);
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击隐藏的处理方法
            console.log(2);
            this.batchHide();
          } else {
            Vue.swal("请选择要隐藏的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤稿的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要撤稿的内容");
            return;
          }
        }
        if (obj.batch == 4) {
          if (this.choiceListIds.length) {
            //点击修改媒体号的处理方法
            this.$refs.media.showModel(this.choiceListIds, "article");
            this.choiceListIds = [];
          } else {
            Vue.swal("请选择要修改的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "articleDetail",
      });
    },

    //去编辑
    // toDetail(item, isModify) {
    //   let id = item.id;
    //   let isLock = true;
    //   let name = JSON.parse(this.cookies.getCookie("user")).username;
    //   console.log(name);
    //   let params = {
    //     id,
    //     isLock,
    //     name,
    //   };

    //   article.lock(params).then((res) => {
    //     console.log(res);
    //     if (name == res.data) {
    //       if (isModify) {
    //         this.$router.push({
    //           name: "articleDetail",
    //           query: { id: item.id, isModify: true, params },
    //         });
    //       } else {
    //         this.$router.push({
    //           name: "articleDetail",
    //           query: { id: item.id, params },
    //         });
    //       }
    //     } else {
    //       Vue.swal(`此项被${res.data}锁定`);
    //     }
    //   });
    // },
    toDetail(item, isModify) {
      if (isModify) {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id, isModify: true },
        });
      } else {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id },
        });
      }
    },

    // 去文章的评论列表
    toComments(item) {
      this.$router.push({
        name: "articleComments",
        query: { id: item.id },
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.repeatTitle = this.pageParams.title;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.contentKeyword = "";
      this.pageParams.tagId = "";
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.pageParams.title = "";
      this.repeatTitle = "";
      this.currentTag = [];
      this.getList();
    },

    selectTags() {
      this.pageParams.tagId = this.currentTag.toString();
      this.getList();
      console.log(this.pageParams.tagId);
    },
    searchTagChange(selectTags) {
      this.pageParams.tagId = selectTags.toString();
      this.search();
    },
    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "desc"; //默认倒序
      }
      this.getList();
    },

    batchHide(item) {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.hide(params).then((resp) => {
            if (resp.code === 0) {
              this.success("隐藏成功");
              // this.getList(); 修改状态成功不刷新列表，直接更改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 0,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
      // article.beforeRemove(params).then((resp) => {
      //   let contentIndexId = [];
      //   let cspId = [];
      //   let subjectId = [];
      //   let collectionId = [];
      //   if (resp.data.isContentCarousel) {
      //     contentIndexId = resp.data.isContentCarousel.map(function(val) {
      //       return val.contentIndexId;
      //     });
      //     console.log(contentIndexId);
      //   }
      //   if (resp.data.isCSP) {
      //     cspId = resp.data.isCSP.map(function(val) {
      //       return val.cspId;
      //     });
      //     console.log(cspId);
      //   }
      //   if (resp.data.isSubject) {
      //     subjectId = resp.data.isSubject.map(function(val) {
      //       return val.subjectId;
      //     });
      //     console.log(subjectId);
      //   }
      //   if (resp.data.isVideoCollection) {
      //     collectionId = resp.data.isVideoCollection.map(function(val) {
      //       return val.collectionId;
      //     });
      //     console.log(collectionId);
      //   }

      //   console.log("ss", resp.data);
      //   if (contentIndexId[0] || cspId[0] || subjectId[0] || collectionId[0]) {
      //     Swal.fire({
      //       title: `本内容已被添加到
      //            ${
      //              contentIndexId[0] ? "轮播图ID" + contentIndexId + "\n" : ""
      //            }${cspId[0] ? "晨视频ID" + cspId + "\n" : ""}${
      //         subjectId[0] ? "专题ID" + subjectId + "\n" : ""
      //       }${
      //         collectionId[0] ? "视频合集ID" + collectionId + "\n" : ""
      //       } 确认隐藏？`,
      //       icon: "question",
      //       showCancelButton: true,
      //       confirmButtonColor: "#f46a6a",
      //       cancelButtonColor: "#74788d",
      //       confirmButtonText: "删除",
      //       cancelButtonText: "取消",
      //     }).then((result) => {
      //       if (result.value) {
      //         let params = {};
      //         if (item) {
      //           params.ids = [];
      //           params.ids.push(item.id);
      //         } else {
      //           params.ids = this.choiceListIds;
      //         }
      //         article.hide(params).then((resp) => {
      //           if (resp.code == 0) {
      //             Vue.swal({
      //               icon: "success",
      //               title: "隐藏成功！",
      //               showConfirmButton: false,
      //               timer: 1000,
      //             });
      //             this.getList();
      //           } else {
      //             Vue.swal(resp.msg);
      //           }
      //         });
      //       }
      //     });
      //   } else {
      //     Swal.fire({
      //       title: "确定隐藏?",
      //       icon: "question",
      //       showCancelButton: true,
      //       confirmButtonColor: "#f46a6a",
      //       cancelButtonColor: "#74788d",
      //       confirmButtonText: "隐藏",
      //       cancelButtonText: "取消",
      //     }).then((result) => {
      //       if (result.value) {
      //         let params = {};
      //         if (item) {
      //           params.ids = [];
      //           params.ids.push(item.id);
      //         } else {
      //           params.ids = this.choiceListIds;
      //         }
      //         article.hide(params).then((resp) => {
      //           if (resp.code == 0) {
      //             Vue.swal({
      //               icon: "success",
      //               title: "隐藏成功！",
      //               showConfirmButton: false,
      //               timer: 1000,
      //             });
      //             this.getList();
      //           } else {
      //             Vue.swal(resp.msg);
      //           }
      //         });
      //       }
      //     });
      //   }
      // });
    },

    batchShow(item) {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.show(params).then((resp) => {
            if (resp.code === 0) {
              this.success("显示成功");
              // this.getList(); 修改状态后不调用列表接口，直接改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 1,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤稿?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          article.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤稿成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 撤销成功直接更改列表数据
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      let params = {};
      params.id = item.id;
      article.beforeRemove(params).then((resp) => {
        console.log("移除检测", resp);
        if (resp.code !== 0) {
          this.$message.warning(resp.msg);
          return;
        }
        let contentIndexId = [];
        let cspId = [];
        let subjectId = [];
        let collectionId = [];
        console.log("移除前", resp);
        if (resp.data.isContentCarousel) {
          contentIndexId = resp.data.isContentCarousel.map(function(val) {
            return val.contentIndexId;
          });
          console.log(contentIndexId);
        }
        if (resp.data.isCSP) {
          cspId = resp.data.isCSP.map(function(val) {
            return val.cspId;
          });
          console.log(cspId);
        }
        if (resp.data.isSubject) {
          subjectId = resp.data.isSubject.map(function(val) {
            return val.subjectId;
          });
          console.log(subjectId);
        }
        if (resp.data.isVideoCollection) {
          collectionId = resp.data.isVideoCollection.map(function(val) {
            return val.collectionId;
          });
          console.log(collectionId);
        }

        if (resp.code == 0) {
          console.log("ss", resp.data);
          if (
            contentIndexId[0] ||
            cspId[0] ||
            subjectId[0] ||
            collectionId[0]
          ) {
            Swal.fire({
              title: `本内容已被添加到
                 ${
                   contentIndexId[0] ? "轮播图ID" + contentIndexId + "\n" : ""
                 }${cspId[0] ? "晨视频ID" + cspId + "\n" : ""}${
                subjectId[0] ? "专题ID" + subjectId + "\n" : ""
              }${
                collectionId[0] ? "视频合集ID" + collectionId + "\n" : ""
              } 确认移除？`,
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#f46a6a",
              cancelButtonColor: "#74788d",
              confirmButtonText: "删除",
              cancelButtonText: "取消",
            }).then((result) => {
              if (result.value) {
                let params = {};
                if (item) {
                  params.ids = [];
                  params.ids.push(item.id);
                } else {
                  params.ids = this.choiceListIds;
                }
                console.log("移除参数", params);
                article.remove(params).then((resp) => {
                  if (resp.code === 0) {
                    this.success("删除成功");
                    // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
                    if (this.items.length == params.ids.length) {
                      this.getList();
                    } else {
                      this.pageTotal -= params.ids.length;
                      this.items = changeList(
                        "delete",
                        this.items,
                        params.ids,
                        "id"
                      );
                      if (!item) {
                        this.choiceListIds = [];
                      }
                    }
                  } else {
                    this.warning(resp.msg || "删除失败");
                  }
                });
              }
            });
          } else {
            Swal.fire({
              title: "确定删除?",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#f46a6a",
              cancelButtonColor: "#74788d",
              confirmButtonText: "删除",
              cancelButtonText: "取消",
            }).then((result) => {
              if (result.value) {
                let params = {};
                if (item) {
                  params.ids = [];
                  params.ids.push(item.id);
                } else {
                  params.ids = this.choiceListIds;
                }
                article.remove(params).then((resp) => {
                  if (resp.code === 0) {
                    this.success("删除成功");
                    // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
                    if (this.items.length == params.ids.length) {
                      this.getList();
                    } else {
                      this.pageTotal -= params.ids.length;
                      this.items = changeList(
                        "delete",
                        this.items,
                        params.ids,
                        "id"
                      );
                      if (!item) {
                        this.choiceListIds = [];
                      }
                    }
                  } else {
                    this.warning(resp.msg || "删除失败");
                  }
                });
              }
            });
          }
        } else {
          console.log("ass", resp);
        }
      });
    },
    // 去文章的评论列表
    toComments(item) {
      this.$router.push({
        name: "articleComments",
        query: { id: item.id },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep .el-table thead .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table thead .el-table__cell:first-child .cell .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep
  .el-table
  tbody
  > .el-table__row
  .el-table__cell:first-child
  .cell
  .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .el-table thead .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:last-child .cell {
  padding-right: 0px !important;
}
</style>
<style>
.list-header .app-list-sort .font-size-28 {
  font-size: 28px;
}
.iframe-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.app-list-sort .dropdown-toggle {
  background-color: transparent !important;
  border-color: none !important;
  border: none !important;
  outline: none;
  padding: 0 !important;
  box-shadow: none !important;
}

.app-list-sort .dropdown-toggle .bx-filter-alt {
  color: #495057;
}

.app-list-sort .dropdown-menu {
  left: inherit !important;
  right: 0 !important;
}

.app-list-sort .dropdown-item i {
  margin-right: 5px;
}

.app-list-sort .dropdown-item .padleft {
  padding-left: 23px;
}
</style>
